import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/AppShell.js';
import { OnboardingWizard } from './components/OnboardingWizard.js';
import { DashboardPage } from './pages/DashboardPage.js';
import { ComposerPage } from './pages/ComposerPage.js';
import { SessionsPage } from './pages/SessionsPage.js';
import { CampaignDetailPage } from './pages/CampaignDetailPage.js';
import { ReportsPage } from './pages/ReportsPage.js';
import { StatsPage } from './pages/StatsPage.js';
import { GuidePage } from './pages/GuidePage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { ActivatePage } from './pages/ActivatePage.js';
import { AdminShell } from './components/AdminShell.js';
import { AdminLoginPage } from './pages/admin/AdminLoginPage.js';
import { CustomersPage } from './pages/admin/CustomersPage.js';
import { NewCustomerPage } from './pages/admin/NewCustomerPage.js';
import { CustomerDetailPage } from './pages/admin/CustomerDetailPage.js';

export function App(): JSX.Element {
  return (
    <Routes>
      {/* Public — the real login flow (email → password → SMS OTP). */}
      <Route path="/login" element={<LoginPage />} />

      {/* Public — customer first-login activation (opened from the invite link). */}
      <Route path="/activate/:token" element={<ActivatePage />} />

      {/* Guided onboarding wizard — full-screen (no app chrome). The app is LOCKED behind it until
          setup is complete (AppShell redirects here); once ready, StepReady sends the user into /. */}
      <Route path="/welcome" element={<OnboardingWizard />} />

      {/* Super-admin console — its OWN platform session (separate storage key). A tenant session
          grants nothing here; AdminShell redirects to /admin/login when no platform token exists. */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminShell />}>
        <Route index element={<Navigate to="/admin/customers" replace />} />
        <Route path="customers" element={<CustomersPage />} />
        <Route path="customers/new" element={<NewCustomerPage />} />
        <Route path="customers/:id" element={<CustomerDetailPage />} />
      </Route>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="composer" element={<ComposerPage />} />

        {/* Merged Reports (שידורים · לחיצות · היסטוריה). Old URLs redirect in. */}
        <Route path="reports" element={<ReportsPage />} />
        <Route path="reports/:tab" element={<ReportsPage />} />
        <Route path="stats" element={<StatsPage />} />
        <Route path="campaigns" element={<Navigate to="/reports" replace />} />
        <Route path="campaigns/:id" element={<CampaignDetailPage />} />
        <Route path="links" element={<Navigate to="/reports/clicks" replace />} />
        <Route path="activity" element={<Navigate to="/reports/history" replace />} />

        {/* Numbers + groups merged into one setup hub. */}
        <Route path="sessions" element={<SessionsPage />} />
        <Route path="targets" element={<Navigate to="/sessions" replace />} />

        {/* Settings hub: settings + פרסום אוטומטי + משתמשים as sections. Old URLs redirect in. */}
        <Route path="settings" element={<SettingsPage />} />
        <Route path="settings/:section" element={<SettingsPage />} />
        <Route path="news" element={<Navigate to="/settings/news" replace />} />
        <Route path="team" element={<Navigate to="/settings/team" replace />} />
        <Route path="guide" element={<GuidePage />} />
      </Route>
    </Routes>
  );
}
